import { MaskModel } from './model.interface';

export const date: MaskModel = {
  mask: [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/]
};